import { Attributes, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class InternalApproverPortalUser extends TemporalEntity {
    static typeName = "InternalApproverPortalUser";

    constructor() {
        super();
        this.makeObservable();
    }

    public internalApproverPortalUserId: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public internalApproverId: number | null = null;

    @Rules.Required()
    public portalUserId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.internalApproverPortalUserId) {
            return "New user";
        } else {
            return `${this.internalApproverPortalUserId} - ${this.internalApproverPortalUserId}`;
        }
    }
}